import React from "react";
import { Formik, Form, Field } from "formik";
import { TextField, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../app/main/shared-components/loading-button/LoadingButton"; 
import authServices from "../../../app/services/auth.service"; 
import { resetPasswordFormStyles } from "./resetPasswordFormStyles";
import { successMsg, errorMsg } from "../../../app/utils/MessageUtils";
import { useDispatch } from "react-redux";
const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const classes = resetPasswordFormStyles();
  const dispatch = useDispatch();

  const initialValues = {
    oldPassword: "",
    newPassword: "",
  };

  const onSubmit = async (values: typeof initialValues, { resetForm }: any) => {
    try {
      await authServices.resetPasswordAgent(values);

      dispatch(successMsg(t("app.main.resetPassword.success", "Password reset successfully")));

      resetForm();
    } catch (error: any) {
      dispatch(errorMsg(t("app.main.resetPassword.error", "Failed to reset password")));
    }
  };

  return (
    <div className={classes.formWrapper}>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ values, handleChange }) => (
          <Form>
            <div className={classes.row}>
              <Typography style={{ marginRight: "2rem", width: "140px" }}>
                {t("app.main.resetPassword.oldPassword.label", "Old Password")}:
              </Typography>
              <Field
                as={TextField}
                type="password"
                size="small"
                variant="outlined"
                name="oldPassword"
                value={values.oldPassword}
                onChange={handleChange}
                className={classes.textField}
                label={t(
                  "app.main.resetPassword.oldPassword.placeholder",
                  "Enter old password"
                )}
                required
              />
            </div>

            <div className={classes.row}>
              <Typography style={{ marginRight: "2rem", width: "140px" }}>
                {t("app.main.resetPassword.newPassword.label", "New Password")}:
              </Typography>
              <Field
                as={TextField}
                type="password"
                size="small"
                variant="outlined"
                name="newPassword"
                value={values.newPassword}
                onChange={handleChange}
                className={classes.textField}
                label={t(
                  "app.main.resetPassword.newPassword.placeholder",
                  "Enter new password"
                )}
                required
              />
            </div>

            <div className={classes.alignRight}>
              <LoadingButton
                btnTitle={t("app.main.resetPassword.submit", "Reset Password")}
                type="submit"
                isLoading={false}
                variant="outlined"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
